import { AllRmColumnsResponseModel, RmColumnsDropDownResponseModel, RmColumnsResponseModel, RmCreateColumnsResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
// import { ColumnsDtoActive } from '../columns/dto/columns_active_inactive';
import { RmColumnsRequest } from './dto/rm-column.request';
import { RmColumnsDTO } from './dto/rm-columns-dto';
import { RmColumnsDtoActive } from './dto/rm-columns_active_inactive';
import { RmZoneRackLevelByIdDto } from './dto/rm-zoneId-request-dto';
import { RmcolumnByIdDto } from './dto/rm.column.dto';
import { RmColumnsService } from './rm-column-service';
import { RmColumns } from './rm-columns-entity';

@Controller('rmcolumns')
export class RmColumnsController {
    constructor(private columnsService: RmColumnsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }
    
      @Post('/createColumns')
      async createColumns(@Body() columnsDto: RmColumnsDTO): Promise<RmCreateColumnsResponseModel>  {
        try {
          return await this.columnsService.CreateColumns(columnsDto, false);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(RmCreateColumnsResponseModel, error);
        }
      }
    
    
      @Post('/updateColumns')
      async updateColumns(@Body() columnsDto: RmColumnsDTO): Promise<RmCreateColumnsResponseModel>  {
        try {
          return await this.columnsService.CreateColumns(columnsDto, true);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(RmCreateColumnsResponseModel, error);
        }
      }
    
    
      @Post('getRecordByColumnsId')
      async getRecordByColumnsId(@Body() id: RmcolumnByIdDto): Promise<RmColumnsResponseModel> {
        try {
          return await this.columnsService.getRecordByColumnsId(id.columnsId);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(RmColumnsResponseModel, error);
        }
      }
      @Post('getAllColumns')
      async getAllColumns():Promise<AllRmColumnsResponseModel> {
        try {
          return await this.columnsService.getAllColumns();
        } catch (error) {
          return this.applicationExceptionHandler.returnException(AllRmColumnsResponseModel, error);
        }
      }
      @Post('activateorDeactivateColumn')
      async activateorDeactivateColumn(@Body() ColumnAct: RmColumnsDtoActive):Promise<RmColumnsResponseModel> {
        try {
          return await this.columnsService.activateorDeactivateColumn(ColumnAct);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(RmColumnsResponseModel, error);
        }
      }
      @Post('/updateRack')
       async updateRack(@Body() columnsDto:RmColumnsDTO,isUpdate:boolean=true): Promise<RmColumnsResponseModel> {
           try {
            return await this.columnsService.CreateColumns(columnsDto,true);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(RmColumnsResponseModel, error);
          }
        }
        @Post('/getAllColumnDropDown')
        async getAllColumnDropDown(): Promise<RmColumnsDropDownResponseModel> {
            try {
             return await this.columnsService.getAllColumnDropDown();
           } catch (error) {
                return this.applicationExceptionHandler.returnException(RmColumnsDropDownResponseModel, error);
           }
         }
    
         @Post('/getColumnById')
         async getColumnById(@Body() columnsreq: RmColumnsRequest): Promise<RmColumns> {
             try {
                 return await this.columnsService.getColumnById(columnsreq.columnsId);
             } catch (err) {
                 throw err;
             }
         }


         @Post('/getColumnsForZoneLevelRackId')
         async getColumnsForZoneLevelRackId(@Body() zoneRackLevelIdReq:RmZoneRackLevelByIdDto): Promise<RmColumnsDropDownResponseModel> {
             try {
              return await this.columnsService.getColumnsForZoneLevelRackId(zoneRackLevelIdReq);
            } catch (error) {
                 return this.applicationExceptionHandler.returnException(RmColumnsDropDownResponseModel, error);
            }
          }
    
    
}
